import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Logo from '../Logo';
import signInStyle from '../../styles/SignIn.module.scss';
import appStyle from '../../styles/App.module.scss';
import { BASE_API_URL } from '../../constants/constants';
import { getUserToken } from '../../services/localStorage';

const Certificate = () => {
    const { course_id, module_id } = useParams();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        handleGetCertificate();
    }, [location]);

    const handleGetCertificate = async () => {
        try {
            setLoading(true);

            const response = await downloadCertificates(course_id, module_id);

            if (!response.ok) {
                const errorMessage = response.statusText || 'HTTP error';
                throw new Error(`${errorMessage}! Status: ${response.status}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Certificate.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            setMessage('Certificate downloaded successfully.');

        } catch (error) {
            console.error('Error getting certificate:', error);
            setMessage('An error occurred while getting certificate. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const downloadCertificates = async (course_id, module_id) => {
        const token = getUserToken();
        const headers = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        return fetch(
            `${BASE_API_URL}/users/course/${course_id}/certificate?module_id=${module_id}`,
            headers
        );
    };

    return (
        <div className={signInStyle['form-wrapper']}>
            <div className={appStyle['form-header-container']}>
                <Logo />
                <p className="mb-2 mt-4 font-18 text-color-primary font-poppins fw-500">
                    {loading ? 'Getting certificate...' : message}
                </p>
            </div>
        </div>
    );
};

export default Certificate;
